import React from "react";
import { FloatingRoadmapWidget } from "@/components/roadmap/FloatingRoadmapWidget";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-background border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4">
        {/* Desktop layout */}
        <div className="hidden md:flex flex-row justify-between items-center gap-4">
          <div className="text-sm text-muted-foreground">
            © 2025 Growth Hackers Company LLC. All rights reserved.
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <span>Found a bug or have feedback?</span>
              <FloatingRoadmapWidget inline={true} />
            </div>
            
            <div className="flex gap-4 text-sm text-muted-foreground">
              <a href="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</a>
              <a href="/terms" className="hover:text-foreground transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>

        {/* Mobile layout - single column */}
        <div className="md:hidden flex flex-col items-center gap-1 text-sm text-muted-foreground">
          {/* Row 1: Copyright */}
          <div>© 2025 GrowthHackers Inc. All rights reserved.</div>
          
          {/* Row 2: Bug feedback */}
          <div className="flex items-center gap-2">
            <span>Found a bug or have feedback?</span>
            <FloatingRoadmapWidget inline={true} />
          </div>
          
          {/* Row 3: Privacy Policy */}
          <a href="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</a>
          
          {/* Row 4: Terms of Service */}
          <a href="/terms" className="hover:text-foreground transition-colors">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};